export class MapPosition {
  lat = 38.8894838;
  lng = -77.0352791;
}
